import {client} from './client';

class problemTypeGroupsApi {

    static async all(activeOnly = true) {
        let groups = await client.get('/problem_type_groups' + (activeOnly ? '' : '?activeOnly=0'));
        return groups.data;
    }

    static async get(id) {
        let status = await client.get('/problem_type_groups/' + id);
        return status.data;
    }

    static async update(model) {
        return await client.patch('/problem_type_groups/' + model.id, model);
    }

    static async create(model) {
        return await client.post('/problem_type_groups', model);
    }

    static async delete(id) {
        return await client.delete('/problem_type_groups/' + id);
    }
}

export default problemTypeGroupsApi;